import type {RadioField, FieldReturn} from '../../types'
import {mergeConfig} from '../../configStore'
import {string} from '../types'
import {mapRadioList, type RadioList} from '../../utils'

export const radio = (
  optionList: RadioList,
  props?: RadioField,
  mergeProps?: Partial<RadioField>,
): FieldReturn => {
  const defaultProps: Partial<RadioField> = {
    options: {
      direction: 'horizontal',
      layout: 'radio',
      list: mapRadioList(optionList),
    },
  }

  return string(mergeConfig('radio', props, mergeProps, defaultProps))
}
